import React, {useEffect, useState} from 'react';
import {Membership} from "types/Membership";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";

type Props = {
    membership: Membership | null
    show: boolean
    onDelete?: (membership: Membership) => any
    onDeleteFail?: (membership: Membership, error: unknown) => any
    onCancel?: () => any
}

function DeleteMembership(props: Props) {
    const {membership, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(membership?.number || 'this membership ');
    const {mutateAsync: deleteMembership} = useMutation(ngage.memberships.destroy)

    useEffect(() => {
        if(membership) setName(membership.number)
    }, [membership]);

    async function handleDeleteMembership() {
        if (membership) {
            try {
                await deleteMembership(membership.id)
                await invalidate('memberships.all')

                if (onDelete) onDelete(membership)
            } catch (error) {
                if (onDeleteFail) onDeleteFail(membership, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Membership "
            body={`Are you sure you want to permanently delete membership '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteMembership}
            onCancel={handleCancel}
        />
    );
}

export default DeleteMembership;